import React, { useState } from 'react';
import axios from 'axios';
import config from './config.js';
import { useNavigate } from 'react-router-dom';

export default function LoginRegisterTabs() {
  const [tab, setTab] = useState('login');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [fullName, setFullName] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const response = await axios.post(`${config.apiUrl}/api/users/login`, {
        username,
        password,
      });
      const { token, fullName, isAdmin } = response.data;
      sessionStorage.setItem('isLoggedIn', 'true');
      sessionStorage.setItem('token', token);
      sessionStorage.setItem('fullName', fullName);
      sessionStorage.setItem('username', username);
      sessionStorage.setItem('isAdmin', isAdmin);
      sessionStorage.setItem("userId", response.data.userId);
      if(isAdmin === true)
      {
        navigate('/admin/dashboard');
      }
      else
      {
        navigate('/dashboard');
      }
      
    } catch (err) {
      setError(err.response?.data?.message || 'Giriş başarısız.');
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await axios.post(`${config.apiUrl}/api/users/register`, {
        username,
        password,
        email,
        fullName,
      });
      alert('Kayıt başarılı! Giriş yapabilirsiniz.');
      setTab('login');
      setUsername('');
      setPassword('');
      setEmail('');
      setFullName('');
    } catch (err) {
      setError(err.response?.data?.message || 'Kayıt başarısız.');
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-gray-100 to-indigo-200 px-4">
      <div className="w-full max-w-md bg-white p-6 rounded-xl shadow-lg">
        <div className="flex mb-6 border-b">
          <button
            onClick={() => setTab('login')}
            className={`w-1/2 text-center py-2 font-medium ${
              tab === 'login' ? 'border-b-2 border-indigo-500 text-indigo-700' : 'text-gray-500'
            }`}
          >
            Giriş Yap
          </button>
          <button
            onClick={() => setTab('register')}
            className={`w-1/2 text-center py-2 font-medium ${
              tab === 'register' ? 'border-b-2 border-indigo-500 text-indigo-700' : 'text-gray-500'
            }`}
          >
            Kayıt Ol
          </button>
        </div>

        {error && <div className="text-red-600 text-sm mb-4 text-center">{error}</div>}

        {tab === 'login' ? (
          <form onSubmit={handleLogin} className="space-y-4">
            <input
              type="text"
              placeholder="Kullanıcı Adı"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:ring-indigo-300"
            />
            <input
              type="password"
              placeholder="Şifre"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:ring-indigo-300"
            />
            <button
              type="submit"
              className="w-full bg-indigo-600 text-white py-2 rounded-md hover:bg-indigo-700"
            >
              Giriş Yap
            </button>
          </form>
        ) : (
          <form onSubmit={handleRegister} className="space-y-4">
            <input
              type="text"
              placeholder="Kullanıcı Adı"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:ring-indigo-300"
            />
            <input
              type="email"
              placeholder="E-posta"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:ring-indigo-300"
            />
            <input
              type="text"
              placeholder="Ad Soyad"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              required
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:ring-indigo-300"
            />
            <input
              type="password"
              placeholder="Şifre"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:ring-indigo-300"
            />
            <button
              type="submit"
              className="w-full bg-indigo-600 text-white py-2 rounded-md hover:bg-indigo-700"
            >
              Kayıt Ol
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
